import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { fonts } from '@theme/fontsCustomer';
import { TechnicalSupportListTable } from './TechnicalSupportListTable';

export const TechnicalSupportList = () => {
  const { t } = useTranslation();
  return (
    <TechnicalSupportListLayOut>
      <Tittle>{t('Technical_Support_List.Title')}</Tittle>
      <TechnicalSupportListTable />
    </TechnicalSupportListLayOut>
  );
};

const TechnicalSupportListLayOut = styled.section`
  width: 100%;
  height: calc(100vh - var(--manager-gnb-height));
  overflow: auto;
  display: flex;
  flex-direction: column;
  padding: 28px 32px;
`;

const Tittle = styled.section`
  ${fonts.Headline5}
  padding: 0px 0px 14px 8px;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors['border-gray-lighter']}`};
`;
